import { DatePipe } from '@angular/common';
import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import { AuthenticationService } from 'src/app/services/authentication.service';
import { ConnectionService } from 'src/app/services/connection.service';
import { LoaderService } from 'src/app/services/loader.service';
import { StorageService } from 'src/app/services/storage.service';
import { ToastService } from 'src/app/services/toast.service';

@Component({
  selector: 'app-profile',
  templateUrl: './profile.page.html',
  styleUrls: ['./profile.page.scss'],
})
export class ProfilePage implements OnInit {

  userdetails:any;
  userDob: any;
  addressdetails:any;
  useremail:any;
  showwithoutedit:boolean = true;
  showlastname:boolean = true;
  showaddress:boolean = true;
  firstname : any;
  lastname: any;
  address: any;
  access_token: string;

  constructor(private strg: StorageService,
    private router: Router,
    private apiService: ConnectionService,
    private authService: AuthenticationService,
    private toast: ToastService,
    private _loader: LoaderService,
    private datePipe: DatePipe) { 
      this.strg.getStoreData("insAccessToken").then(res=>{
        this.access_token = res;
      });
    }

  ngOnInit() {   
    this.strg.getStoreData("userObj").then(res=>{     
      this.userdetails = res; 
      this.useremail = this.userdetails.email;
      this.userDob = this.datePipe.transform(this.userdetails.dob, "dd-MM-yyyy");
      console.log('aaaaaaaaaaaa', this.userdetails) ; 
      console.log('ttttttttttttttttttttt', this.useremail);
      this.getaddress(this.useremail); 
    },err=>{     
    });
   
  }

  logoutClicked(){
    this.authService.revokeAuthTokenOnLogout(this.access_token, this.userdetails.id).subscribe(ress => {
      console.log("token revoked!")
      this.strg.removeStoreData("userObj").then(res => {
        this.strg.removeStoreData("insAccessToken").then(res => {
          this.strg.removeStoreData("insRefreshToken").then(res => {
            this.authService.authState.next(false);
            // this.router.navigate(['/login']);
            // this.router.navigate(['login'], { queryParams: { returnUrl: this.router.url }});
            window.open("https://www.mypolicyjunction.com/", "_self");
          });
        });
      });
    });
  }

  getaddress(useremail){
    // this.apiService.getaddress(useremail).subscribe(res => { //for direct ref
    this.apiService.getaddress().subscribe(res => {
      console.log(res,'tttttttttttttttttt');
    },err=>{
      console.log(err,'eroooooo');
    });
  }

  
  edituserfirstname(){
    this.showwithoutedit = false;   
  }

  edituserlastname(){
    this.showlastname = false;
  }

  editaddress(){
    this.showaddress = false;
  }


  updatefirst(){
    this.useremail = this.userdetails.email;
    let data = {
      // "email" : this.userdetails.email, //for direct ref
      "status" : "FIRSTNAME",
      "value" : this.firstname
    }
    this._loader.showLoader("Please Wait..."); 
    this.apiService.saveBasicUserDetails(data).subscribe(res=>{
      this._loader.hideLoader();
      console.log(res,'firstname');   
      this.showwithoutedit = true;   
      this.getUserDetailsHere(data);
    },err=>{
      this._loader.hideLoader();
      console.log(err,'error')
    }); 
  }


  updatelast(){
    this.useremail = this.userdetails.email;
    let data ={
      // "email" : this.userdetails.email, //for direct ref
      "status" : "LASTNAME",
      "value" : this.lastname
    }
    this._loader.showLoader("Please Wait..."); 
    this.apiService.saveBasicUserDetails(data).subscribe(res=>{
      this._loader.hideLoader();
      console.log(res,'lastname');
      this.showlastname = true;
      this.getUserDetailsHere(data);
    },err=>{
      this._loader.hideLoader();
      console.log(err,'error')
    });
  }

  updateaddress(){
    this._loader.showLoader("Please Wait...");   
    let data ={
      // "email" : this.userdetails.email, //for direct ref
      "address": this.address
    }  
    // this.apiService.editaddress(data.email,data.address).subscribe(res=>{ //for direct ref
    this.apiService.editaddress(data.address).subscribe(res=>{
      this._loader.hideLoader();
      if(res.status = 200){
        console.log(res,'address');
        this.showaddress = true;  
        this.getUserDetailsHere(data);
      }   
    },err=>{
      this._loader.hideLoader();
      console.log(err,'error')
    })
  }

  getUserDetailsHere(data){
    console.log(data,'data of updated value')
    this._loader.showLoader("Please Wait..."); 
    // this.authService.getUserDetails(data.email).subscribe(res => { //for direct ref
    this.authService.getUserDetails().subscribe(res => {
      console.log("get user details", res);
      if(res.status === "OK"){
        this.strg.setStoreData("userObj",res.data).then(res => {
          this._loader.hideLoader();
          console.log(res,'newobject');
         
          this.toast.showToast('Profile updated succesfully!');   
          this.ngOnInit();
        });
      }
    }, err => {
      this._loader.hideLoader();
      console.log("get userdetails error",)
    })
  }

  validateLettersOnly(event) {
    console.log("target", event);
    if (!/^[a-zA-Z ]*$/g.test(event.key)) {
      return false;
    } else {
      return true;
    }
  }

  validateAddressdd(e) {
    var code = ('charCode' in e) ? e.charCode : e.keyCode;
    console.log("codeeeeee", code);
    if (!(code == 32) && // space
      !(code == 46) && // space
      !(code == 47) && // space
      !(code == 44) && // space
      !(code > 47 && code < 58) && // numeric (0-9)
      !(code > 64 && code < 91) && // upper alpha (A-Z)
      !(code > 96 && code < 123)) { // lower alpha (a-z)
      e.preventDefault();
    }
  }


}
